import React, { Component } from "react";
import axios from "axios";
import DashboardStats from "./DashboardStats";
// import tags from "../big-text/tags";
import keys from "../config";
import "../style/Dashboard.css";
export class Dashboard extends Component {
  constructor(props) {
    super(props);
    /* REPLACE WITH TAGS FROM DB */
    // const voices = tags.voicings;
    // const composers = tags.composers;
    // const liturgicalSeason = tags.liturgicalSeason;
    // const massParts = tags.massParts;
    // const misc = tags.misc;
    /* REPLACE WITH TAGS FROM DB */

    this.state = {
      access: true,
      file: null,
      unAuthFile: null,
      pieceName: "",
      composer: "",
      categories: [],
      newCategory: "",
      uploadStatus: null,
      voices: null,
      composers: null,
      liturgicalSeason: null,
      massParts: null,
      misc: null,
      loadSpinner: false,
      tagAdd: "",
      categoryOfTagAdd: "voices",
      tagsLoaded: false
    };
    this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleComposer = this.handleComposer.bind(this);
    this.handlePieceName = this.handlePieceName.bind(this);
    this.addCheckboxItemToState = this.addCheckboxItemToState.bind(this);
    this.removeCheckboxItemToState = this.removeCheckboxItemToState.bind(this);
    this.handleUnAuthFileUploadChange = this.handleUnAuthFileUploadChange.bind(
      this
    );
    this.clearInputs = this.clearInputs.bind(this);
    this.addCategory = this.addCategory.bind(this);
    this.addCustomCategory = this.addCustomCategory.bind(this);
    this.removeCategory = this.removeCategory.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleAddTag = this.handleAddTag.bind(this);
    this.handleAddTagInput = this.handleAddTagInput.bind(this);
    this.handleAddTagCategory = this.handleAddTagCategory.bind(this);
  }
  async componentDidMount() {
    const jwt = localStorage.getItem("token");
    const url =
      "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/grant-access";
    const data = {
      jwt
    };
    try {
      const result = await axios.post(url, data);
      const { access } = result.data;
      this.setState({ access });
    } catch (error) {
      console.error(error);
    }
    try {
      const url =
        "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/dashboard/getTag";
      const result = await axios.post(url);
      const tags = result.data.tags.Items;
      const catNames = tags.map(i => i.category);
      for (let i = 0; i < tags.length; i++) {
        const cat = catNames[i];
        const tagArr = tags[i].tags;
        this.setState({
          [cat]: tagArr
        });
      }
      this.setState({
        tagsLoaded: true
      });
    } catch (error) {
      console.log("ERROR FETCHING TAGS", error.response);
    }
  }
  handleFileUploadChange(event) {
    this.setState({ file: event.target.files[0] });
  }
  handleUnAuthFileUploadChange(event) {
    this.setState({ unAuthFile: event.target.files[0] });
  }
  async handleFormSubmit(event) {
    event.preventDefault();
    if (!this.state.file) {
      return this.setState({
        uploadStatus: "You have to upload a file for paid users"
      });
    } else if (!this.state.unAuthFile) {
      return this.setState({
        uploadStatus: "You have to upload a file for unpaid users (vistors)"
      });
    }
    this.setState({
      loadSpinner: true
    });
    // the formData object gets sent to the server. It's like filling out the fields of a Postman HTTP request
    let formData = new FormData();
    formData.append("file", this.state.file);
    formData.append("unAuthFile", this.state.unAuthFile);
    formData.append("pieceName", this.state.pieceName);
    formData.append("composer", this.state.composer);
    formData.append("category", this.state.categories);

    try {
      // upload file
      const url = keys.uploadUrl;
      const uploadResult = await axios.post(url, formData, {
        headers: { Authorization: localStorage.getItem("token") }
      });
      // console.log("upload result", uploadResult);
      if (uploadResult.data === true) {
        window.location.reload();
      } else {
        return this.setState({
          uploadStatus: uploadResult.data.errorMessage
        });
      }
    } catch (error) {
      console.error(error);
      return this.setState({
        uploadStatus: `${error.name}: ${error.message}`
      });
    }
  }
  handlePieceName(e) {
    this.setState({ pieceName: e.target.value });
  }
  handleComposer(e) {
    this.setState({ composer: e.target.value });
  }
  async handleAddTag(e) {
    e.preventDefault();
    try {
      const url =
        "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/dashboard/addTag";
      const data = {
        category: this.state.categoryOfTagAdd,
        tag: this.state.tagAdd
      };
      console.log("data", data);
      await axios.post(url, data);
      this.setState({
        tagAdd: ""
      });
    } catch (error) {
      console.log("ERROR WITH GET TAGS FROM DB", error);
    }
  }
  handleAddTagInput(e) {
    const { value } = e.target;
    this.setState({
      tagAdd: value
    });
  }
  handleAddTagCategory(e) {
    const { value } = e.target;
    this.setState({
      categoryOfTagAdd: value
    });
  }
  addCategory(el) {
    if (this.state.categories.indexOf(el) !== -1) {
      return this.setState(prevState => {
        return {
          categories: [...prevState.categories.filter(item => item !== el)]
        };
      });
    }
    this.setState(prevState => {
      return {
        categories: [...prevState.categories, el]
      };
    });
  }
  handleKeyUp(event) {
    // this function allows the user to submit a tag with "Enter"
    if (event.key === "Enter" && this.state.newCategory.trim().length > 0) {
      const ø = {};
      this.addCustomCategory(ø);
    }
  }
  addCustomCategory(e) {
    if (e.key === "Enter") {
      return null;
    }
    this.setState(prevState => {
      return {
        categories: [...prevState.categories, this.state.newCategory]
      };
    });

    this.setState({
      newCategory: ""
    });
  }

  addCheckboxItemToState(item, e) {
    e.target.parentNode.classList.add("active-category");
    this.setState({
      categories: [...this.state.categories, item]
    });
  }
  removeCheckboxItemToState(item) {
    const newCategories = this.state.categories.filter(tag => tag !== item);
    this.setState({
      categories: newCategories
    });
  }
  removeCategory(cat) {
    this.setState(prevState => {
      return {
        categories: [...prevState.categories.filter(item => item !== cat)]
      };
    });
  }
  clearInputs() {
    this.setState({
      file: null,
      unAuthFile: null,
      pieceName: "",
      composer: "",
      categories: [],
      uploadStatus: null
    });
  }
  render() {
    if (!this.state.tagsLoaded) {
      return (
        <div>
          <h1>LOADING</h1>
        </div>
      );
    } else {
      return (
        <div>
          <div className="dashboard-logo">
            <h1 className="dashboard-title">English Motets Dashboard</h1>
            <img
              height="150px"
              src="https://upload.wikimedia.org/wikipedia/commons/6/6e/Circle-icons-speedometer.svg"
              alt="dashboard logo"
            />
            <div className="dashboard-stats">
              <DashboardStats />
            </div>
            <div className="dashboard-instructions">
              <h2 className="tip">How it works:</h2>
              <p className="tip">
                When you fill out the upload form below, the information you
                provide goes in several directions. The data (tags, name, etc)
                used to categorize the motet will be put into a remote database.
                The files themselves will live in a thing called an S3 bucket.
              </p>
              <p className="tip">
                Because of the nature of Adobe, you'll have to upload two PDFs
                of the same motet. A one-page "sample" version for users who
                have not yet paid and a "complete" version for users who have
                paid. They will live in two different storage buckets. That way,
                only authorized users will have access to the complete score.
              </p>
              <p className="tip">
                This form is smart enough to ensure that you don't upload the
                same file twice (unless you change the filename). It will let
                you know when you do that. As mentioned above, the next step is
                for you to be able to update files, categories, titles, etc.
              </p>
              <p className="tip">
                Finally, when naming your piece, <em>do not</em> include the
                composer name. This app will automatically put the composer name
                into the link. It will resemble cpdl's link
              </p>
            </div>
          </div>
          <div className="dashboard">
            <div className="dashboard-console">
              <h1 className="input-form-title">Upload a motet</h1>
              <div>
                <div className="dash-input">
                  <label
                    className={
                      this.state.pieceName
                        ? "dash-input-helper-active"
                        : "dash-input-helper"
                    }
                  >
                    Name of piece
                  </label>
                  <input
                    placeholder="English Title / Latin Title"
                    onChange={this.handlePieceName}
                    value={this.state.pieceName}
                    type="text"
                  />
                </div>
                <div className="dash-input">
                  <label
                    className={
                      this.state.composer
                        ? "dash-input-helper-active"
                        : "dash-input-helper"
                    }
                  >
                    Composer(s)
                  </label>
                  <input
                    placeholder="Name of composer(s):"
                    onChange={this.handleComposer}
                    value={this.state.composer}
                    type="text"
                  />
                </div>
                <div className="dash-file-input">
                  {this.state.file && (
                    <div>
                      <h3>Complete score: {this.state.file.name}</h3>
                      <h4 className="tip">
                        Last modified:{" "}
                        {String(this.state.file.lastModifiedDate)}
                      </h4>
                    </div>
                  )}
                  <div className="upload-btn-wrapper">
                    <button className="btn dash-file-btn">
                      Upload a complete file for users
                    </button>
                    <input
                      accept="application/pdf"
                      onChange={this.handleFileUploadChange}
                      type="file"
                    />
                  </div>
                </div>
                <div className="dash-file-input">
                  {this.state.unAuthFile && (
                    <div>
                      <h3>One page score: {this.state.unAuthFile.name}</h3>
                      <h4 className="tip">
                        Last modified:{" "}
                        {String(this.state.file.lastModifiedDate)}
                      </h4>
                    </div>
                  )}
                  <div className="upload-btn-wrapper">
                    <button className="btn dash-file-btn">
                      Upload a one-page file for visitors
                    </button>
                    <input
                      accept="application/pdf"
                      onChange={this.handleUnAuthFileUploadChange}
                      type="file"
                    />
                  </div>
                </div>
                <div className="form-section-title">
                  <h1>Add some tags!</h1>
                  <p>
                    When you think of some new search tags, you can add them to
                    a database
                  </p>
                </div>
                <div className="add-tags">
                  <form onSubmit={this.handleAddTag}>
                    <select onChange={this.handleAddTagCategory}>
                      <option value="voices">Voicings</option>
                      <option value="composers">Composers</option>
                      <option value="liturgicalSeason">
                        Liturgical season
                      </option>
                      <option value="massParts">Mass parts</option>
                      <option value="misc">Misc</option>
                    </select>
                    <input
                      value={this.state.tagAdd}
                      type="text"
                      onChange={this.handleAddTagInput}
                    />
                    <button type="submit">Add to database</button>
                  </form>
                </div>
                <div className="category-section-title">
                  <h2>Voices:</h2>
                </div>
                <div className="checkboxes">
                  <ul className="tag-list">
                    {this.state.voices.map(el => (
                      <li
                        className={
                          this.state.categories.indexOf(el) !== -1
                            ? "tag-item tag-list-item-active"
                            : "tag-item"
                        }
                        onClick={() => this.addCategory(el)}
                        key={el}
                      >
                        {el}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="category-section-title">
                  <h2>Composers:</h2>
                </div>
                <div className="checkboxes">
                  <ul className="tag-list">
                    {this.state.composers.map(el => (
                      <li
                        className={
                          this.state.categories.indexOf(el) !== -1
                            ? "tag-item tag-list-item-active"
                            : "tag-item"
                        }
                        onClick={() => this.addCategory(el)}
                        key={el}
                      >
                        {el}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="category-section-title">
                  <h2>Liturgical season:</h2>
                </div>
                <div className="checkboxes">
                  <ul className="tag-list">
                    {this.state.liturgicalSeason.map(el => (
                      <li
                        className={
                          this.state.categories.indexOf(el) !== -1
                            ? "tag-item tag-list-item-active"
                            : "tag-item"
                        }
                        onClick={() => this.addCategory(el)}
                        key={el}
                      >
                        {el}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="category-section-title">
                  <h2>Mass parts:</h2>
                </div>
                <div className="checkboxes">
                  <ul className="tag-list">
                    {this.state.massParts.map(el => (
                      <li
                        className={
                          this.state.categories.indexOf(el) !== -1
                            ? "tag-item tag-list-item-active"
                            : "tag-item"
                        }
                        onClick={() => this.addCategory(el)}
                        key={el}
                      >
                        {el}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="category-section-title">
                  <h2>Misc tags:</h2>
                </div>
                <div className="checkboxes">
                  <ul className="tag-list">
                    {this.state.misc.map(el => (
                      <li
                        className={
                          this.state.categories.indexOf(el) !== -1
                            ? "tag-item tag-list-item-active"
                            : "tag-item"
                        }
                        onClick={() => this.addCategory(el)}
                        key={el}
                      >
                        {el}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="form-summary">
                  <h4>Piece name: {this.state.pieceName}</h4>
                  <h4>Composer: {this.state.composer}</h4>
                  <h4>Categories:</h4>
                  <ul className="form-summary-list">
                    {this.state.categories.map(cat => (
                      <li
                        onClick={() => this.removeCategory(cat)}
                        className="form-summary-list-item"
                        key={cat + "un"}
                      >
                        {cat}
                      </li>
                    ))}
                  </ul>
                </div>
                <p>
                  <em>Want to add a custom tag not mentioned above?</em>
                </p>
                <div className="add-custom-category">
                  <input
                    value={this.state.newCategory}
                    onChange={e =>
                      this.setState({ newCategory: e.target.value })
                    }
                    onKeyUp={this.handleKeyUp}
                    className="sign-input"
                    type="text"
                    placeholder="Add a tag and press enter!"
                  />
                  {/* <button
                    type="button"
                    onClick={this.addCustomCategory}
                    className="btn"
                  >
                    Add tag
                  </button> */}
                </div>
                <div className="dash-btn">
                  <button
                    onClick={this.handleFormSubmit}
                    className="btn"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </div>
              {this.state.uploadStatus && (
                <div className="flash">{this.state.uploadStatus}</div>
              )}
              {this.state.loadSpinner && !this.state.uploadStatus && (
                <div>
                  <div className="spinner-holder">
                    <div className="circle">
                      <div className="sub-circle" />
                    </div>
                  </div>
                  <div style={{ textAlign: "center" }}>Loading</div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js